"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messageConfigApi = messageConfigApi;
exports.messageUpdateConfigApi = messageUpdateConfigApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @description 获取佣金配置
 */
function messageConfigApi() {
  return (0, _request.default)({
    url: "/admin/platform/carouselAds/detail",
    method: 'GET'
  });
}

/**
 * 保存佣金配置
 */
function messageUpdateConfigApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/carouselAds/save',
    method: 'POST',
    data: data
  });
}